import React, { useState } from 'react'
import {
  DropdownButton,
  DropdownItem,
  DropdownList,
  DropdownWrapper,
} from './style'
import SvgImage from '@components/svg'

type StatusDropdownProps<T extends Record<string, any>> = {
  value: string
  onChange: (key: string) => void
  options: T[]
  valueAsKey: keyof T
  titleAsKey: keyof T
  isLast?: boolean
}

const StatusDropdown = <T extends Record<string, any>>({
  value,
  onChange,
  options,
  valueAsKey,
  titleAsKey,
  isLast,
}: StatusDropdownProps<T>) => {
  const [isOpen, setIsOpen] = useState(false)

  const selectedOption = options.find((opt) => opt[valueAsKey] === value)
  let activeBg = ''

  switch (value) {
    case 'Available':
      activeBg = 'primary50'
      break
    case 'Unavailable':
      activeBg = 'unavailable'
      break
    case 'Reserved':
      activeBg = 'reserved'
      break
  }

  return (
    <DropdownWrapper>
      <DropdownButton onClick={() => setIsOpen(!isOpen)} bg={activeBg}>
        {selectedOption ? selectedOption[titleAsKey] : 'Select'}
        <SvgImage src="down" />
      </DropdownButton>

      {isOpen && (
        <DropdownList isLast={isLast}>
          {options.map((option) => (
            <DropdownItem
              key={option[valueAsKey]}
              onClick={() => {
                onChange(option[valueAsKey])
                setIsOpen(false)
              }}
            >
              {option[titleAsKey]}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </DropdownWrapper>
  )
}

export default StatusDropdown
